import styled, {css} from "styled-components"

import {Card} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"

export const Wrapper = styled.div`
  margin-bottom: ${({theme}) => theme.spacing.three};
  .slick-track {
    display: flex !important;
  }
  .slick-slide {
    padding: 0 ${({theme}) => theme.spacing.one};
    height: inherit !important;
  }
  .slick-slide > div {
    height: 100%;
  }
  .slick-list {
    margin: 0 -${({theme}) => theme.spacing.one};
  }
`

export const StyledImg = styled.img`
  border-radius: ${({theme}) => theme.spacing.one};
`

export const StyledCard = styled(Card)<{bgColor: string}>`
  ${({theme, bgImg}) => css`
    width: 50%;
    min-height: 100%;
    background: linear-gradient(0deg, ${theme.colors.primary2}, ${theme.colors.primary2}80), url(${bgImg});
    background-size: cover;
    background-position: center;
    & > div {
      height: 100%;
    }
  `}
`

export const WidthCard = styled(Card)`
  width: 50%;
`

export const UsersCircle = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.one};
    width: 125px;
    height: 125px;
    border-radius: 50%;
    background-color: ${theme.colors.utility.white};
    display: inline-block;
  `}
`
export const Container = styled(Flex)`
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.largeDesktop`
        flex-direction: column;
        > div {
          width: 100%;
        }
      `}
  `}
`
